import * as types from '../types';
import { IReportDraft } from '../common/defaults';

export interface IReportState {
  reportDrafts: IReportDraft[];
  DriverReportFormIoFormId: string;
}

const initialState: IReportState = {
  reportDrafts: [],
  DriverReportFormIoFormId: '',
};

export default (state: IReportState = initialState, action: any) => {
  let _state = { ...state };
  switch (action.type) {
    case types.LOAD_ALL_TYPES_INTO_STORE:
      return {
        ...state,
        reportDrafts: [...state.reportDrafts, ...action.value],
      };
    case types.GET_FORM_IO_FORM_ID:
      return {
        ...state,
        DriverReportFormIoFormId: action.value,
      };
    default:
      return state;
  }
};
